import { StringLike } from "@firebase/util";
import {
  Avatar,
  CardContent,
  Divider,
  Grid,
  Tab,
  Tabs,
  Typography,
  // Button
} from "@mui/material";
import { Theme } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import moment from 'moment';
import * as qs from 'query-string';
import React, { createContext, useEffect, useState, Dispatch } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import { setMissionMetadata } from "../actions/missionMetadata";
import {  
    getUserGameLog, 
    getUserGameLogRankMode,
    getMahjongBehaviorAverage,
    getMissionDomain,
    getUserScore,
    MahjongBehaviorAverageData,
    getUserCalligraphyData,
    getAllMissionDataOfUser
} from '../api';
import CalligraphyTab from "../components/CalligraphyTab";
import MahjongTab from '../components/MahjongTab';
import MissionTab from '../components/MissionTab';
import PlaytimeTab from '../components/PlaytimeTab';
import { ReactFade } from "../components/ReactFade";
import SelectUserDropdown from '../components/SelectUserDropdown';
import SimpleSnackBar, { SnackBarProp } from "../components/SimpleSnackBar";
import { firebaseUser } from "../firebase";
import { AppState } from '../reducers';
import { StyledCircularProgress } from '../StyledComponents';
import { CalligraphyRecordEntry } from "../types/CalligraphyData";
import { GameLog } from '../types/GameLog';
import { AllMissionDataType, MissionData } from '../types/MissionData';
import { 
    domains, 
    DomainType, 
    MissionMetadata,
    MissionType 
} from '../types/MissionType';
import { UserProfile } from '../types/UserProfile';
import { isTrialAccount, RoleType } from '../types/UserRole';
import CenterMissionTab from "./CenterMissionTab";
// import Button from '@mui/material/Button';
import { render } from 'react-dom';
import { renderToString } from 'react-dom/server';
import { Template, generate, BLANK_PDF } from "@pdfme/generator";
import templateChinese from '../pdf/templateChinese.json';
import domtoimage from 'dom-to-image';

import tick from '../image/tick.png';
import empty from '../image/empty.png';
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    avatarPos: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    avatarSize: {
      width: theme.spacing(18),
      height: theme.spacing(18),
    },
    grid: {
      flexGrow: 1,
    }
  }),
);

const StyledInfoContent = styled.div`
    font-size: 20px;
    color: #000000; 
    text-align: center;
`
const StyledReportHeader = styled.div`
    font-size: 16px;
    padding-bottom: 1px;
    text-align: left;
`
const StyledReportContent = styled.div`
    font-size: 16px;
    color: #757575; 
    padding-top: 8px;
    text-align: left;
`
const StyledGridRow = styled(Grid)`
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 40px;
    padding-right: 40px;
`

type Font = {
  [fontName: string]: {
    data: Uint8Array | ArrayBuffer;
    fallback?: boolean;
    subset?: boolean;
  }
}

export const formatMinigameData = (data: AllMissionDataType[]) => {
  let tempData = data.map(row => {
    const temp = moment.utc(row.task_start_time).local().format('YYYY/MM/DD')
    return { "date": temp, "playtime": (row.task_end_time - row.task_start_time) < 0 ? 0 : (row.task_end_time - row.task_start_time) };
  })
  tempData = tempData.sort(function (a, b) {
    return (a.date < b.date)? -1 : (a.date > b.date)? 1 : 0;
  });
  return tempData.filter(d => d.playtime > 0);
}

export const MissionMetadataContext = createContext<MissionMetadata | undefined>(undefined);

export const formatCalligraphyPlaytimeData = (data: CalligraphyRecordEntry[]) => {
  let tempData = data.map(row => {
    const temp = moment.utc(row.timestamp).local().format('YYYY/MM/DD')
    return { "date": temp, "playtime": row.data.timeTaken, type: row.type };
  })
  tempData = tempData.sort(function (a, b) {
    return (a.date < b.date)? -1 : (a.date > b.date)? 1 : 0;
  });
  return tempData;
}

export const formatMahjongData = (data: GameLog[]) => {
  let tempData = data.map(row => {
    const temp = moment.utc(row.game_start_time).local().format('YYYY/MM/DD')
    return { "date": temp, "playtime": row.game_end_time - row.game_start_time };
  })
  tempData = tempData.sort(function (a, b) {
    return (a.date < b.date)? -1 : (a.date > b.date)? 1 : 0;
  });
  return tempData;
}

export const formatMinigameData1 = (data: AllMissionDataType[]) => {
  let tempData = data.map(row => {
    const temp = moment.utc(row.task_start_time).local().format('YYYY/MM')
    return { "date": temp, "playtime": (row.task_end_time - row.task_start_time) < 0 ? 0 : row.task_end_time - row.task_start_time, "key": row.key };
  })
  tempData = tempData.sort(function (a, b) {
    return (a.date < b.date)? -1 : (a.date > b.date)? 1 : 0;
  });
  return tempData;
}

export const formatMahjongData1 = (data: GameLog[]) => {
  let tempData = data.map(row => {
    const temp = moment.utc(row.game_start_time).local().format('YYYY/MM')
    return { "date": temp, "playtime": row.game_end_time - row.game_start_time };
  })
  tempData = tempData.sort(function (a, b) {
    return (a.date < b.date)? -1 : (a.date > b.date)? 1 : 0;
  });
  return tempData;
}

export const countPlaytime = (tempData: { "date": string, "playtime": number }[]) => {
  let arr: { "date": string, "playtime": number }[] = [{ "date": "", "playtime": 0 }];
  tempData.reduce<any>(function (res, value) {
    if (!res[value.date]) {
      res[value.date] = { date: value.date, playtime: 0 };
      arr.push(res[value.date])
    }
    res[value.date].playtime += value.playtime;
    return res;
  }, {});
  arr = arr.filter(x => x.date !== "" && x.date !== "1970/01/01");
  return arr;
}

export const countPlaytimeWithTypes = (tempData: { "date": string, "payload": number, "type": string }[], timeConvertFunc?: (input: number) => number, avg?: boolean) => {

  const allTypes = tempData.map(d => d.type);
  const distinctTypes: string[] = allTypes.filter((item, pos) => allTypes.indexOf(item) == pos);

  let arr: { "date": string, "type": { [key: string]: { "sum": number, "count": number } | number } }[] = [];
  tempData.reduce<any>(function (res, value) {
    if (!res[value.date]) {
      res[value.date] = { date: value.date, type: distinctTypes.reduce((a: { [key: string]: { "sum": number, "count": number } }, b: string) => (a[b] = { "sum": 0, "count": 0 }, a), {}) };
      arr.push(res[value.date])
    }

    res[value.date].type[value.type].sum += timeConvertFunc ? timeConvertFunc(value.payload) : value.payload;
    res[value.date].type[value.type].count++;

    return res;
  }, {});
  arr = arr.filter(x => x.date !== "" && x.date !== "1970/01/01");

  arr.forEach(entry => {
    Object.entries(entry.type).forEach(([key, value]) => {
      const castValue: { sum: number, count: number } = value as { sum: number, count: number };
      entry.type[key] = (avg !== undefined && avg === true) ? Math.round(castValue.sum / castValue.count * 100) / 100 : entry.type[key] = castValue.sum;
    })
  });

  return arr;
}

export const computeProjectedScore = (score: number, level: number, maxLevel: number) => {
  const MINIMUM_LEVEL_SCORE_CEILING = 40;
  const MAXIMUM_LEVEL_SCORE_CEILING = 100;
  const levelCeilingScoreStep = (maxLv: number) => (MAXIMUM_LEVEL_SCORE_CEILING - MINIMUM_LEVEL_SCORE_CEILING) / maxLv;
  const currentLevelScoreCeiling = (currLv: number, maxLv: number) => MINIMUM_LEVEL_SCORE_CEILING + currLv * levelCeilingScoreStep(maxLv);

  return Math.round((score / 10) * currentLevelScoreCeiling(level, maxLevel));
}

export default function NewReportPage(props: { setTitle: Dispatch<React.SetStateAction<string>>}) {
  const Navigate = useNavigate();
  const dispatch = useDispatch();

  const {t} = useTranslation();

  // const generatePDF = async () => {
  //   const template: Template = templateChinese as Template

  //   const userSmoke = () => {
  //     if (selectedUser?.smoke === 'seldom' || selectedUser?.smoke === 'sometimes' || selectedUser?.smoke === 'always')
  //     return tick
  //   }

  //   const userAlcohol = () => {
  //     if (selectedUser?.drink_alcohol === 'seldom' || selectedUser?.drink_alcohol === 'sometimes' || selectedUser?.drink_alcohol === 'always')
  //     return tick
  //   }

  //   const monthNumber = () => {
  //     const m = document.getElementById('monthGameStat')?.innerHTML.valueOf()
  //     const mSub = m? m.substr(0, m.length-1) : ''
  //     switch (mSub) {
  //       case '一':
  //         return 'Jan'
  //       case '二':
  //         return 'Feb'
  //       case '三':
  //         return 'Mar'
  //       case '四':
  //         return 'Apr'
  //       case '五':
  //         return 'May'
  //       case '六':
  //         return 'Jun'
  //       case '七':
  //         return 'Jul'
  //       case '八':
  //         return 'Aug'
  //       case '九':
  //         return 'Sep'
  //       case '十':
  //         return 'Oct'
  //       case '十一':
  //         return 'Nov'
  //       case '十二':
  //         return 'Dec'
  //       case '全':
  //         return 'Full'
  //     }
  //   }

  //   let canvasRadarChart = document.getElementById('radarChart')
  //   let options = {quality: 1};

  //   let radarChartDataUrl = domtoimage.toPng(canvasRadarChart, options).then((dataUrl: any) => {
  //     console.log(radarChartDataUrl)
  //     return dataUrl
  //   })

  //   // const radarChartDataUrl = ''
  //   // console.log(radarChartDataUrl)

  //   // const canvasRadarChart = document.getElementById('radarChart') as HTMLCanvasElement
  //   // console.log(canvasRadarChart)

  //   // const radarChartDataUrl = canvasRadarChart.toDataURL('image/png')
  //   // console.log(radarChartDataUrl)

  //   const inputs = [
  //     {
  //       name: selectedUser?.name?? "No information", 
  //       gender: selectedUser?.gender ?? "No information", 
  //       age: userAge?.toString() ?? "No information",
  //       smoke: userSmoke() ?? empty,
  //       alcohol: userAlcohol() ?? empty,
  //       exercise: empty,
  //       breakfast: empty,
  //       wakeUpEarly: empty,
  //       playMahJong: empty,
  //       lastGame: missionData? getLastPlaytime_eng(missionData) : '',
  //       timeDaily: missionData? Math.round(getAvgDailyPlaytime(countPlaytime(formatMinigameData(missionData)))).toString() : '-',
  //       gameMonthly: Math.round(getAvgMonthlyGames(_getAvgMonthlyGames(missionData))).toString() ?? '-',
  //       year: document.getElementById('yearGameStat')?.innerHTML.valueOf().substr(0,4)?? "",
  //       month: monthNumber() ?? "",
  //       radar: await radarChartDataUrl
  //     }
  //   ];

  //   console.log("pending");
  //   const pdf = await generate({ template, inputs });

  //   // console.log("success")
  //   // const blob = new Blob([pdf.buffer], { type: "application/pdf" });
  //   // window.open(URL.createObjectURL(blob));
  // }

  // const generatePDF = async () => {
  //   const template: Template = {
  //     basePdf: BLANK_PDF,
  //     schemas: [
  //       {
  //         title: {
  //           type: "text",
  //           fontName: "chinese",
  //           position: { x: 20, y: 20 },
  //           width: 100,
  //           height: 10,
  //         },
  //         body: {
  //           type: "text",
  //           position: { x: 20, y: 35 },
  //           width: 100,
  //           height: 10,
  //         },
  //         sth: {
  //           type: "text",
  //           position: { x: 20, y: 50 },
  //           width: 100,
  //           height: 10,
  //         }
  //       }
  //     ]
  //   };

    // let font_file = fs.readFileSync("../fonts/DFLISM1B.TTF", { encoding: "utf-8" });
    // console.log(font_file)

    // let font_temp = new TTFFont(font_file);
    // let chinese = font_temp.subset();
    // chinese.use('abcdefghijklmnopqrstuvwxyz ABCDEFGHIJKLMNOPQRSTUVWXYZ 1234567890')
    // chinese.embed();

    // const font: Font = {
    //   chinese: {
    //     data: chinese.save(),
    //     fallback: true,
    //   }
    // }

  //   const inputs = [{title: "標題", body: "The body is here.", sth: "My name is brian"}]
    
  //   console.log("pending")
  //   const pdf = await generate({ template, inputs, options: { font: font }});

  //   console.log("success")
  //   const blob = new Blob([pdf.buffer], { type: "application/pdf" });
  //   window.open(URL.createObjectURL(blob));
  // }

  const closeErrorSnackBar = () => {
    setSnackBar({ ...snackBar, "open": false });
    Navigate(-1);
  }

  const [snackBar, setSnackBar] = useState<SnackBarProp>({
    open: false,
    onClose: closeErrorSnackBar,
    message: "",
    variant: undefined
  });

  const loggedInUser = useSelector<AppState, firebaseUser | null>(state => state.loggedInUser);

  const loggedUserRole = useSelector<AppState, RoleType | null>(state => state.userRole);

  const [selectedUser, setSelectedUser] = useState<UserProfile>();

  const [missionData, setMissionData] = useState<AllMissionDataType[]>();

  const [centerMissionDataSnapshot, setCenterMissionDataSnapshot] = useState<AllMissionDataType[] | undefined>();

  const [calligraphyData, setCalligraphyData] = useState<CalligraphyRecordEntry[]>();

  const [domainsScore, setDomainsScore] = useState<{ "domain": string, "chineseDomain": string, "score": number }[]>();

  const [gameLog, setGameLog] = useState<Array<GameLog>>();

  const [gameLogRankMode, setGameLogRankMode] = useState<Array<GameLog>>();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [selectedUserReport, setSelectedUserReport] = useState<string>();

  const [tabNumber, setTabNumber] = useState<number>(0);

  const [mahjongBehaviorAverage, setMahjongBehaviorAverage] = useState<MahjongBehaviorAverageData | undefined>();

  const [userScore, setUserScore] = useState<number>(0);

  const missionMetadata = useSelector<AppState, { metadata: MissionMetadata | null; domainMission: { [key: string]: MissionType[] } }>((state: any) => state.missionMetadata);

  const classes = useStyles();

  const thisYear = new Date().getFullYear();

  const heightChange = selectedUser !== undefined && selectedUser.user_id !== "-1";

  const onUserSelectChange = (selectedUserProfile: UserProfile) => {
    if (selectedUserProfile !== undefined) {
      setSelectedUser(selectedUserProfile);
    }
  };

  useEffect(() => {
    // Preload all mission data if the account is center account
    if (loggedUserRole === "center" || loggedUserRole === "trial_center") {}

    async function setMissionMD() {
      if (!missionMetadata.metadata)
        dispatch(setMissionMetadata(await getMissionDomain()));
    }
    setMissionMD();
    _setMahjongBehaviorAverage();
    props.setTitle("reports");
  }, [])

  useEffect(() => {
    setIsLoading(true);

    if (selectedUser !== undefined)
      Navigate({
        pathname: "/report",
        search: `?uid=${selectedUser?.user_id}`
      });

    const qsObject = qs.parse(window.location.search);
    let uid: string;
    if (qsObject.uid !== undefined && qsObject.uid !== null) {
      if (typeof (qsObject.uid) === "string") {
        uid = qsObject.uid;
        setSelectedUserReport(uid);
      }
    }
    if (selectedUser !== undefined) {
      _setGameLog();
      //_setGameLogRankMode();
      _setMissionData();
      _setCalligraphyData();
      _setUserScore();
    }
    setTabNumber(0);
  }, [selectedUser]);

  useEffect(() => {
    setIsLoading(false);
    _setDomainsScore();
  }, [missionData]);

  useEffect(() => {
    if (gameLog !== undefined) {
      getAvgMahjongGametime(gameLog);
    }
  }, [gameLog])

  const _setGameLog = async () => {
    if (selectedUser !== undefined) {
      setGameLog(await getUserGameLog(selectedUser.user_id));
    }
  }

  const _setGameLogRankMode = async () => {
    if (selectedUser !== undefined) {
      const temp = await getUserGameLogRankMode(selectedUser.user_id);
      let tempData: GameLog[] = [];
      if (temp !== undefined) {
        temp.forEach(x => {
          if (x.players === undefined) {
            console.log(x);
          }
          x?.players?.forEach(player => {
            if (player.user_id === selectedUser.user_id) {
              tempData.push(x);
            };
          })
        })
      }
      tempData.sort((a, b) => {
        return b.game_start_time - a.game_start_time
      })
      setGameLogRankMode(tempData);
    }
  }

  const _setUserScore = async () => {
    if (selectedUser !== undefined)
      setUserScore(await getUserScore(selectedUser.user_id));
  }

  const _setMahjongBehaviorAverage = async () => {
    setMahjongBehaviorAverage(await getMahjongBehaviorAverage());
  }

  useEffect(() => {
    // console.log(mahjongBehaviorAverage);
  }, [mahjongBehaviorAverage]);

  const _setDomainsScore = async () => {
    let scores: {
      "domain": string,
      "chineseDomain": string,
      "score": number
    } = { "domain": "", "chineseDomain": "", "score": 0 };
    let scoresLOL = await Promise.all(
      domains.map(async domain => {
        const score = await getDomainScore(domain);
        scores = {
          "domain": domain,
          "chineseDomain": t(`scheduleMissionPage.item_${domain}` as unknown as TemplateStringsArray),
          "score": score,
        };
        return scores;
      }))
    setDomainsScore(scoresLOL);
  }

  const _setMissionData = async () => {
    // const data = await getAllMissionData()
    if (selectedUser !== undefined) {
      const startCount = window.performance.now();
      let dataArr = await getAllMissionDataOfUser(selectedUser.user_id);
      const endCount = window.performance.now();
      setMissionData(dataArr);

      setSnackBar({
        ...snackBar,
        message: t("msg.loaded_user_mission_data") + ((Math.round(endCount - startCount) / 1000 * 100) / 100).toFixed(1).toString() + " " + t("units_date.second") + "）" ,
        open: true,
        variant: "success",
      });
    }
  }

  const _setCalligraphyData = async () => {
    if (selectedUser !== undefined) {
      setCalligraphyData(await getUserCalligraphyData(selectedUser.user_id));
    }
  }

  const getMissionScore = async (mission: MissionType) => {
    const result: {
      "mission": MissionType,
      "totalScore": number,
      "score": number
    } = { "mission": "", "totalScore": 0, "score": 0 };
    if (selectedUser !== undefined) {
      if (missionData !== undefined) {
        const data = missionData.filter(x => x.key === mission)
        if (data !== null) {
          result.mission = mission;
          result.score = data.reduce((a, b) => a + b.score, 0);
          result.totalScore = data.reduce((a, b) => a + b.total_score, 0);
        }
        return result;
      }
    }
  }

  const getDomainScore = async (domain: DomainType) => {
    let domainScore = 0;
    let DomainTotalScore = 0;
    let TotalDomainScore = 0;
    const arr: MissionType[] = missionMetadata.domainMission[domain] ?? [];
    const result = await Promise.all(arr.map(async x => {
      return await getMissionScore(x);
    }))
    if (result !== null) {
      result.forEach(element => {
        if (element !== undefined && element.score !== undefined && element.totalScore !== undefined) {
          TotalDomainScore += element.totalScore;
          DomainTotalScore += element.score;
        }
      })
    }
    domainScore = DomainTotalScore / TotalDomainScore * 100;
    if (isNaN(domainScore)) {
      domainScore = 0;
    }
    return domainScore;
  }

  const getLastPlaytime = (data: AllMissionDataType[]) => {
    const temp = data.map(row => {
      // if (!row.task_start_time) console.error(row);
      return row.task_start_time;
    })
    const lastPlaytime = Math.max(...temp);
    return moment.utc(lastPlaytime).local().format('YYYY MMM Do HH:mm:ss');

  }

  const getLastPlaytime_eng = (data: AllMissionDataType[]) => {
    const temp = data.map(row => {
      if (!row.task_start_time) console.error(row);
      return row.task_start_time;
    })
    const lastPlaytime = Math.max(...temp);
    return moment.utc(lastPlaytime).local().format('DD MMM YYYY HH:mm:ss')
  }

  const getAvgDailyPlaytime = (arr: { date: string, playtime: number }[]) => {
    const avgPlaytime = arr.reduce((a, b) => a + b.playtime, 0) / arr.length;
    return Math.round(avgPlaytime / 1000 / 60 * 10)/ 10;
  }

  const getAvgDailyGames = (counts: { [key: string]: number }) => {
    const avgGameNo = Object.values(counts);
    return avgGameNo.reduce((a, b) => a + b, 0) / avgGameNo.length;
  }

  const _getAvgDailyGames = (data: any) => {
    let tempData = data.map((row: any) => {
      let take_time = (row.hasOwnProperty("task_start_time"))? row.task_start_time : row.game_start_time;
      return moment.utc(take_time).local().format('YYYY/MM/DD') as string 
    })
    tempData = (tempData as string[]).sort(function (a, b) {
      return (a < b)? -1 : (a > b)? 1 : 0;
    });
    const counts: { [key: string]: number } = {};
    (tempData as string[]).forEach(function (x) {
      counts[x] = (counts[x] || 0) + 1;
    });
    return counts;
  }

  const _getAvgMonthlyGames = (data: any) => {
    let tempData = data.map((row: any) => {
      let take_time = (row.hasOwnProperty("task_start_time"))? row.task_start_time : row.game_start_time;
      return moment.utc(take_time).local().format('YYYY/MM') as string;
    })
    tempData = (tempData as string[]).sort(function (a, b) {
      return (a < b)? -1 : (a > b)? 1 : 0;
    });
    const counts: { [key: string]: number } = {};
    (tempData as string[]).forEach(function (x) {
      counts[x] = (counts[x] || 0) + 1;
    });
    return counts;
  }

  const getAvgMonthlyGames = (counts: { [key: string]: number }) => {
    const avgGameNo = Object.values(counts);
    return avgGameNo.reduce((a, b) => a + b, 0) / avgGameNo.length;
  }

  const getAvgMahjongGametime = (data: GameLog[]) => {
    const gametimeArr = data.map(x => {
      return x.game_end_time - x.game_start_time;
    });
    const avgGametime = gametimeArr.reduce((a, b) => a + b, 0) / gametimeArr.length;
    return Math.round(avgGametime / 1000 / 60 * 10)/ 10;
  }

  const handleTabChange = (newValue: number) => {
    setTabNumber(newValue);
  }

  // const template: Template = {
  //   basePdf: BLANK_PDF,
  //   schemas: [
  //     {
  //       a: {
  //         type: 'text',
  //         position: { x: 0, y: 0 },
  //         width: 10,
  //         height: 10,
  //       },
  //       b: {
  //         type: 'text',
  //         position: { x: 10, y: 10 },
  //         width: 10,
  //         height: 10,
  //       },
  //       c: {
  //         type: 'text',
  //         position: { x: 20, y: 20 },
  //         width: 10,
  //         height: 10,
  //       },
  //     },
  //   ],
  // };

  // const inputs = [{ a: '你好', b: 'b1', c: 'c1' }]

  // const generatePDF = () => {
  //   generate({ template, inputs }).then((pdf) => {
  //     console.log(pdf)
  //     const blob = new Blob([pdf.buffer], { type: 'application/pdf' })
  //     window.open(URL.createObjectURL(blob));
  //   })
  // }

  // const styles = {
  //   fontFamil: 'sans-serif',
  //   textAlifn: 'center'
  // }

  // const colStyle = {
  //   width: '30%'
  // }

  // const tableStyle = {
  //   width: '100%'
  // }

  // const Info = () => {
  //   return (
  //     <>
  //       {selectedUser !== undefined && selectedUser.user_id !== '-1' ?
  //         <div>
  //           <h1>NeuroGym User Report</h1>
  //           {/* <h2>User Information</h2>
  //           <p>Name: {selectedUser.name}</p>
  //           <p>Gender: {selectedUser.gender}</p>
  //           <p>Age: {(selectedUser.year_of_birth !== null && selectedUser.year_of_birth !== undefined) ? thisYear - selectedUser.year_of_birth : "No Information"}</p>
  //           <p>Occupation (Previous/Current): {(selectedUser.occupation !== null && selectedUser.occupation !== undefined) ? selectedUser.occupation : "No Information"}</p>
  //           <h2>Personal Lifestyle</h2>
  //           <p>Dementia Diagnosis Result: {(selectedUser.dementia_diagnosis !== null && selectedUser.dementia_diagnosis !== undefined) ? translation[selectedUser.dementia_diagnosis] : "No Information"}</p>
  //           <p>Occupation(Previous/Current): {(selectedUser.occupation !== null && selectedUser.occupation !== undefined) ? selectedUser.occupation : "No Information"}</p>
  //           <p>Familiarity of Using Mobile Gadgets: {(selectedUser.use_smartphone_level !== null && selectedUser.use_smartphone_level !== undefined) ? translation[selectedUser.use_smartphone_level] : "No Information"}</p>
  //           <p>Education Level: {(selectedUser.education_level !== null && selectedUser.education_level !== undefined) ? translation[selectedUser.education_level] : "No Information"}</p>
  //           <p>Familiarity of Playing Mahjong: {(selectedUser.mahjong_level !== null && selectedUser.mahjong_level !== undefined) ? translation[selectedUser.mahjong_level] : "No Information"}</p>
  //           <p>Frequency of Smoking: {(selectedUser.smoke !== null && selectedUser.smoke !== undefined) ? translation[selectedUser.smoke] : "No Information"}</p>
  //           <p>Frequency of Drinking Alcoholic Drinks: {(selectedUser.drink_alcohol !== null && selectedUser.drink_alcohol !== undefined) ? translation[selectedUser.drink_alcohol] : "No Information"}</p>
  //           <h2>Game Statistics</h2>
  //           <p>Last Game: {missionData !== undefined && missionData.length !== 0 ? getLastPlaytime_eng(missionData) : "No Data"}</p>
  //           <p>Daily Average Game Time: {missionData !== undefined && missionData.length !== 0 ? getAvgDailyPlaytime(countPlaytime(formatMinigameData(missionData))) + " minute(s)" : "No Data"}</p>
  //           <p>Daily Average Game: {missionData !== undefined && missionData.length !== 0 ? Math.round(getAvgDailyGames(_getAvgDailyGames(missionData))) + " time(s)" : "No Data"} </p>
  //           <p>Monthly Average Game: {missionData !== undefined && missionData.length !== 0 ? Math.round(getAvgMonthlyGames(_getAvgMonthlyGames(missionData))) + " game(s)" : "No Data"}</p>
  //           <p>Average Mahjong Time: {gameLog !== undefined && gameLog.length !== 0 ? getAvgMahjongGametime(gameLog) + " minute(s)" : "No Data"}</p>
  //           <p>Daily Average Mahjong Game: {gameLog !== undefined && gameLog.length !== 0 ? Math.round(getAvgDailyGames(_getAvgDailyGames(gameLog))) + " game(s)" : "No Data"}</p>
  //           <p>Monthly Average Mahjong Game: {gameLog !== undefined && gameLog.length !== 0 ? Math.round(getAvgMonthlyGames(_getAvgMonthlyGames(gameLog))) + " game(s)" : "No Data"}</p>
  //           <h2>Game Results</h2>
  //           <h3>User Level</h3>
  //           <p>Current Level: Lv.{getLevelByScore(userScore).level}</p>
  //           <p>Total Exp: {userScore}</p>
  //           <p>Exp Required to Upgrade: {getLevelByScore(userScore).next}</p>
  //           <h3>Missions Preference</h3>
  //           <p>Most Played Game: </p>
  //           <h3>Performance</h3> */}
  //         </div>
  //       : null}
  //     </>
  //   )
  // }

  // const print = () => {
  //   const string = renderToString(<Info />);
  //   const pdf = new jsPDF('l', 'mm', 'a4');
  //   pdf.html(string);
  //   pdf.save(selectedUser?.name + '.pdf');
  // }

  // const print = () => {
  //   const input = document.getElementById('info')!;
  //   const pdf = new jsPDF('p', 'mm', 'a4');
  //   var width = pdf.internal.pageSize.getWidth();
  //   var height = pdf.internal.pageSize.getHeight();
  //   var imgW = width*1152/1903.200;
  //   var imgH = height*1552.26/1701.260;
  //   var imgX = (width-imgW)/2
  //   var imgY = (height-imgH)/2
  //   var tabName = ''
  //   if (tabNumber === 0) {
  //     tabName = '游戲成績'
  //   }
  //   if (tabNumber === 1) {
  //     tabName = '麻雀成績'
  //   }
  //   if (tabNumber === 2) {
  //     tabName = '書法數據'
  //   }
  //   if (tabNumber === 3) {
  //     tabName = '游戲時間'
  //   }
  //   html2canvas(input).then((canvas) => {
  //     const imgData = canvas.toDataURL('image/png');
  //     pdf.addImage(imgData, 'png', imgX, imgY, imgW, imgH);
  //     pdf.save(selectedUser?.name + "_" + tabName + ".pdf");
  //   })
  // }

  // const print = () => {
  //   const input = document.getElementById('info')!;
  //   html2canvas(input).then((canvas) => {
  //     const pdf = new jsPDF('l', 'mm', 'a4');
  //     pdf.html(input)
  //     pdf.save("download.pdf")
  //   })
  // }

  const userAge = selectedUser?.year_of_birth !== null && selectedUser?.year_of_birth !== undefined ? thisYear - selectedUser?.year_of_birth : null

  return (

    <div>
      {/* <SimpleAppBar title={'報告'} /> */}
      <SimpleSnackBar open={snackBar.open} onClose={closeErrorSnackBar} message={snackBar.message} variant={snackBar.variant} autoClose={snackBar.autoClose} />
      {(loggedInUser !== undefined && loggedUserRole !== null && !isTrialAccount(loggedUserRole)) ?
        <div className={classes.grid} style={{ paddingTop: 50 }}>
          <Grid container spacing={1}>
            <Grid item sm={3} xs={12}>
              <Typography component="div" style={{ backgroundColor: '#d3ebee', height: heightChange && !isLoading ? '100%' : '120vh', flex: 1 }} >
                <StyledGridRow>
                  <CardContent>
                    {selectedUser !== undefined && selectedUser.user_id !== '-1' ?
                      <div className={classes.avatarPos}>
                        <Avatar src={selectedUser.avatar_url} className={classes.avatarSize}/>
                      </div>
                      : null}
                    {loggedInUser !== null && selectedUserReport === undefined ? 
                      <SelectUserDropdown onUserSelectChange={onUserSelectChange} /> 
                      :
                      <SelectUserDropdown onUserSelectChange={onUserSelectChange} selectedUserId={selectedUserReport} />
                    }
                  </CardContent>
                </StyledGridRow>
                {selectedUser !== undefined && selectedUser.user_id !== '-1' ?
                  <div>
                    <StyledGridRow style={{ display: "inline-block", flex: 1, flexDirection: "column", alignItems: "center" }}>
                      <StyledInfoContent>
                        {t("common.name")}： {selectedUser.name}
                      </StyledInfoContent>
                      {
                        selectedUser.gender && (
                          <StyledInfoContent>
                            {t("common.gender")}： {selectedUser.gender}
                          </StyledInfoContent>
                        )
                      }
                      {
                        selectedUser.year_of_birth && (
                          <StyledInfoContent>
                            {t("common.age")}： {selectedUser?.year_of_birth !== null && selectedUser?.year_of_birth !== undefined ? thisYear - selectedUser?.year_of_birth : null}
                          </StyledInfoContent>
                        )
                      }
                    </StyledGridRow>
                    {!isLoading &&
                      <>
                        <StyledGridRow>
                          <CardContent>
                            <StyledReportHeader>
                              {t("new_report_pages.persoanl_habbits")}
                            </StyledReportHeader>
                            <Divider variant="fullWidth" />
                            {selectedUser.dementia_diagnosis !== undefined && selectedUser.dementia_diagnosis !== null &&
                              <StyledReportContent>
                                {t("common.dementia_diagnosis")}： {t(`dementia_diagnosis.${selectedUser.dementia_diagnosis}` as unknown as TemplateStringsArray)}
                              </StyledReportContent>}
                            {selectedUser.occupation !== undefined && selectedUser.occupation !== null && selectedUser.occupation !== "" &&
                              <StyledReportContent>
                                {t("common.occupation_previous_or_present")}： {selectedUser.occupation}
                              </StyledReportContent>}
                            {selectedUser.use_smartphone_level !== undefined && selectedUser.use_smartphone_level !== null &&
                              <StyledReportContent>
                                {t("common.use_smartphone_level")}： {t(`use_smartphone_level.${selectedUser.use_smartphone_level}` as unknown as TemplateStringsArray)}
                              </StyledReportContent>}
                            {selectedUser.education_level !== undefined && selectedUser.education_level !== null &&
                              <StyledReportContent>
                                {t("common.education_level")}： {t(`education_level.${selectedUser.education_level}` as unknown as TemplateStringsArray)}
                              </StyledReportContent>}
                            {selectedUser.mahjong_level !== undefined && selectedUser.mahjong_level !== null &&
                              <StyledReportContent>
                                {t("common.mahjong_level")}： {t(`mahjong_level.${selectedUser.mahjong_level}` as unknown as TemplateStringsArray)}
                              </StyledReportContent>}
                            {selectedUser.smoke !== undefined && selectedUser.smoke !== null &&
                              <StyledReportContent>
                                {t("common.smoke")}： {t(`common_level.${selectedUser.smoke}` as unknown as TemplateStringsArray)}
                              </StyledReportContent>}
                            {selectedUser.drink_alcohol !== undefined && selectedUser.drink_alcohol !== null &&
                              <StyledReportContent>
                                {t("common.drink_alcohol")}： {t(`common_level.${selectedUser.drink_alcohol}` as unknown as TemplateStringsArray)}
                              </StyledReportContent>}

                            {/* if the current user doesn't have any info */}
                            {!(selectedUser.dementia_diagnosis !== undefined && selectedUser.dementia_diagnosis !== null) && !(selectedUser.occupation !== undefined && selectedUser.occupation !== null && selectedUser.occupation !== "") && !(selectedUser.use_smartphone_level !== undefined && selectedUser.use_smartphone_level !== null) && !(selectedUser.education_level !== undefined && selectedUser.education_level !== null) && !(selectedUser.mahjong_level !== undefined && selectedUser.mahjong_level !== null) && !(selectedUser.smoke !== undefined && selectedUser.smoke !== null) && !(selectedUser.drink_alcohol !== undefined && selectedUser.drink_alcohol !== null) && (
                              <>
                                <StyledReportContent>
                                  {t("no__.information")}
                                </StyledReportContent>
                                <StyledReportContent>
                                  {t("new_report_pages.add_more_info_of_user")}
                                </StyledReportContent>
                              </>
                            )
                              
                            }
                          </CardContent>
                        </StyledGridRow>
                        <StyledGridRow>
                          <CardContent>
                            <StyledReportHeader >
                              {t("new_report_pages.gaming_time")}
                          </StyledReportHeader>
                            <Divider variant="fullWidth" />

                            {
                              ((missionData === undefined || missionData.length === 0) && (gameLog === undefined || gameLog.length === 0) ? (
                                <>
                                  <StyledReportContent>
                                    {t("no__.game_record")}
                                  </StyledReportContent>
                                  <StyledReportContent>
                                    {t("common.start_a_game")}
                                  </StyledReportContent>
                                </>
                              )
                              :
                              (
                                <div>
                                  <StyledReportContent>
                                    {t("new_report_pages.last_game")}： {missionData !== undefined && missionData.length !== 0 ? getLastPlaytime(missionData) : t("no__.data")}
                                  </StyledReportContent>
                                  <StyledReportContent>
                                    {t("new_report_pages.avg_daily_gaming_time")}： {missionData !== undefined && missionData.length !== 0 ? getAvgDailyPlaytime(countPlaytime(formatMinigameData(missionData))) + " " + t("units_date.minute") : t("no__.data")}
                                  </StyledReportContent>
                                  <StyledReportContent>
                                    {t("new_report_pages.avg_daily_gaming_times")}： {missionData !== undefined && missionData.length !== 0 ? Math.round(getAvgDailyGames(_getAvgDailyGames(missionData))) + " " + t("common.times") : t("no__.data")}
                                  </StyledReportContent>
                                  <StyledReportContent>
                                    {t("new_report_pages.avg_monthly_gaming_times")}： {missionData !== undefined && missionData.length !== 0 ? Math.round(getAvgMonthlyGames(_getAvgMonthlyGames(missionData))) + " " + t("common.times") : t("no__.data")}
                                  </StyledReportContent>
                                  <StyledReportContent>
                                    {t("new_report_pages.avg_time_for_mahjong")}： {gameLog !== undefined && gameLog.length !== 0 ? getAvgMahjongGametime(gameLog) + " " + t("units_date.minute") : t("no__.data")}
                                  </StyledReportContent>
                                  <StyledReportContent>
                                    {t("new_report_pages.avg_daily_mahjong")}： {gameLog !== undefined && gameLog.length !== 0 ? Math.round(getAvgDailyGames(_getAvgDailyGames(gameLog))) +  " " + t("common.times") : t("no__.data")}
                                  </StyledReportContent>
                                  <StyledReportContent>
                                    {t("new_report_pages.avg_monthly_mahjong")}： {gameLog !== undefined && gameLog.length !== 0 ? Math.round(getAvgMonthlyGames(_getAvgMonthlyGames(gameLog))) + " " + t("common.times") : t("no__.data")}
                                  </StyledReportContent>
                                </div>
                              )
                              )
                            }
                            
                          </CardContent>
                          {/* {(tabNumber === 0) ?
                            <CardContent>
                              <Button variant="outlined" onClick={generatePDF}>生成PDF報告<br></br>(暫時只提供英文版)</Button>
                            </CardContent>
                          : null}  */}
                          
                        </StyledGridRow>
                      </>}
                  </div>
                  : null}
              </Typography>
            </Grid>
            {(selectedUser !== undefined && selectedUser.user_id !== '-1' && !isLoading && domainsScore !== undefined && missionData !== undefined) ?
              <Grid item sm={9} xs={12} style={{ paddingTop: 30 }}>
                <Tabs
                  value={tabNumber}
                  onChange={(e, v) => handleTabChange(v)}
                  indicatorColor="primary"
                  textColor="primary"
                  variant="scrollable"
                  scrollButtons="auto"
                >
                  <Tab label={t("new_report_pages.game_result")} style={{ fontSize: 20 }} value={0} />
                  <Tab label={t("new_report_pages.mahjong_result")} style={{ fontSize: 20 }} value={1} />
                  <Tab label={t("new_report_pages.calligraphy_result")} style={{ fontSize: 20 }} value={2} />
                  <Tab label={t("new_report_pages.gaming_time")} style={{ fontSize: 20 }} value={3} />
                </Tabs>
                <ReactFade in={tabNumber === 0} timeout={750}>
                  <MissionTab domainScore={domainsScore} missionData={missionData} selectedUser={selectedUser} userScore={userScore} />
                </ReactFade>

                <ReactFade in={tabNumber === 1} timeout={750}>
                  <MahjongTab uid={selectedUser.user_id} mahjongData={gameLog} missionData={missionData} mahjongBehaviorAverage={mahjongBehaviorAverage} mahjongBehaviorTrendData={undefined} />
                </ReactFade>

                <ReactFade in={tabNumber === 2} timeout={750} >
                  <CalligraphyTab calligraphyData={calligraphyData === undefined ? [] : calligraphyData} />
                </ReactFade>

                <ReactFade in={tabNumber === 3} timeout={750} >
                  <PlaytimeTab missionData={missionData} mahjongData={gameLog} calligraphyData={calligraphyData} />
                </ReactFade>
              </Grid>
              : (loggedUserRole === "center" || loggedUserRole === "trial_center") ?
                <CenterMissionTab />
                : null
            }
          </Grid>
          {isLoading && <StyledCircularProgress />}
        </div> :
        <SimpleSnackBar open={true} onClose={closeErrorSnackBar} message={t("msg.plz_contact_for_report")} variant="warning" autoClose={99999} />}
    </div >
  )
}